import { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';

import { SitesType } from '@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { AsyncResult } from '@/libraries/signup/bxpkit-core/src/hooks/use-async';
import { useAISAvailableProducts } from '@/libraries/signup/bxpkit-core/src/hooks/use-available-products';

export type SitesContextType = {
	sites?: Array<SitesType>;
};

export const SitesContext = createContext<SitesContextType | null>(null);

/**
 * @deprecated Use UserContextProvider instead
 */
export const useSitesContext = () => {
	const context = useContext(SitesContext);

	if (!context) {
		throw new Error('useSitesContext must be used within a SitesContextProvider');
	}

	return context;
};
export const SitesContextProvider = ({ children }: PropsWithChildren) => {
	const [sites, setSites] = useState<Array<SitesType> | undefined>(undefined);
	const response = useAISAvailableProducts({});

	useEffect(() => {
		if (AsyncResult.isComplete(response)) {
			setSites(response.value?.sites);
		} else if (AsyncResult.isError(response)) {
			setSites([]);
		}
	}, [response]);

	return <SitesContext.Provider value={{ sites }}>{children}</SitesContext.Provider>;
};
